import React from 'react';
import { getUploadedImagePath, MarkupRender, Modal, useAppState } from '@nutastic/nutastic-react-app';

// eslint-disable-next-line react/prop-types
const AboutModal = ({ onClose, isActive }) => {
    const componentClass = 'taroyaModal';
    const { page = {} } = useAppState();
    const {
        field_3: aboutBigTextTitle,
        field_4: aboutBigTextSubtitle,
        field_10: aboutImageText,
        content: aboutSectionContent,
        image_1: aboutImage
    } = page;

    return <Modal
        show={isActive}
        className={componentClass}
        title="About Manifesting Vibes"
        closeOnOuterClick={true}
        onClose={onClose}
        closeBtn={<i className="ion-md-close-circle" />}
    >
        <div className={`${componentClass}__image`}>
            <img src={getUploadedImagePath(aboutImage)} alt={aboutImageText} />
            <span>{ aboutImageText }</span>
        </div>
        <div className={`${componentClass}__info`}>
            <h4>{aboutBigTextTitle}<i>{aboutBigTextSubtitle}</i></h4>
            <MarkupRender content={aboutSectionContent} tagName="div" className='paragraph-content' />
            <small>
                <i>man·i·fest -display or show.</i>
                <i>vibes -a distinctive emotional quality</i>
                <b>#GoodVibesOnly</b>
            </small>
        </div>
    </Modal>;
};

export default AboutModal;
